// extracted by mini-css-extract-plugin
module.exports = {"main":"sponsorSite_main__3mD0p","minNav":"sponsorSite_minNav__O7jjk","nav2":"sponsorSite_nav2__ELY7s"};